export default __webpack_public_path__ + "static/hosting-shape7-8c767263f87069697fd3137e5d565d4f.png";